module.exports = __webpack_public_path__ + "img/text_login.f3b3d4e7.png";